import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { appHelpers } from '../../_helpers';
import {
    Grid,
    FormControl,
    InputLabel
} from "@material-ui/core";
import Add from "@material-ui/icons/AddBox";
import InlineDatePicker from "../../utils/InlineDatePicker";
import AutocompleteSelect from "../../utils/AutocompleteSelect";
import { ProgressBar } from "../../utils/ProgressBar";




const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        // margin: theme.spacing.unit,
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px"
    },
    
});

const SettingsPanel = ({
    classes,
    error,
    formError,
    currentPSCRegionalCharge,
    currentPSCInternationalCharge,
    handleChange,
    handlePsc,
    openModal,
    handleClose,
    fullScreen,
    handlePscSave,
    disabled,
    startDateNew,
    handleDateChange,
    currencyOptions,
    currency,
    reactSelectChange,
    progress,
    serviceType,
    serviceTypesOptions,
    componentErrorMessages
}) => {

    return (
        <div className={classes.root}>
                  <ProgressBar isActive={progress} />
            <form className={classes.container} noValidate>
                <Grid container spacing={24}>
                    <Grid item md={4} xs={12}>
                        <Card>
                            <CardHeader color="danger" stats icon>
                                <CardIcon color="danger">
                                    <Amount />
                                </CardIcon>
                                <div style={{ color: "#212121" }}>
                                    <p className={classes.cardCategory}>Regional Psc Value</p>
                                    <h3 className={classes.cardTitle}>&#36; {typeof (currentPSCRegionalCharge) === "number" ? appHelpers.numberWithCommas(currentPSCRegionalCharge) : currentPSCRegionalCharge}</h3>
                                </div>
                            </CardHeader>
                        </Card>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Card>
                            <CardHeader color="danger" stats icon>
                                <CardIcon color="danger">
                                    <Amount />
                                </CardIcon>
                                <div style={{ color: "#212121" }}>
                                    <p className={classes.cardCategory}>International Psc Value</p>
                                    <h3 className={classes.cardTitle}>&#36; {typeof (currentPSCInternationalCharge) === "number" ? appHelpers.numberWithCommas(currentPSCInternationalCharge) : currentPSCInternationalCharge}</h3>
                                </div>
                            </CardHeader>
                        </Card>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Button
                            color={"regional"}
                            onClick={handlePsc}
                            style={{ marginTop: "3vw" }}

                        >
                            <Add />  Set New PSC
                        </Button>
                    </Grid>
                </Grid>
                <Dialog
                    fullScreen={fullScreen}
                    open={openModal}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: "#04137b" }}>
                        <span style={{ color: "white", textTransform: "uppercase" }}> Set New PSC Charge</span>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={24}>
                            <Grid item md={12} sm={12}>
                            {/* {error && <span style={{ color: "red" }}>{formError}</span>} */}

                                <FormControl
                                fullWidth
                                    className={classNames(classes.airlineSelect, classes.formControl)}
                                >
                                    <CustomInput
                                        required
                                        labelText="New PSC Charges"
                                        id="pscChargesNew"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={
                                            {
                                                name: "pscChargesNew",
                                                type: "number",
                                                onChange: handleChange,
                                            }}
                                    />
                                </FormControl>
                                {componentErrorMessages.pscChargesNew && <span style={{color: "red"}}>{componentErrorMessages.pscChargesNew}</span>}

                            </Grid>

                            <Grid item md={12} sm={12}>
                                <FormControl
                                fullWidth
                                    className={classNames(classes.airlineSelect, classes.formControl)}
                                >
                                    <CustomInput
                                        required
                                        labelText="Old PSC Charges"
                                        id="pscChargesOld"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={
                                            {
                                                name: "pscChargesOld",
                                                type: "number",
                                                onChange: handleChange,
                                            }}
                                    />
                                </FormControl>
                                {componentErrorMessages.pscChargesOld && <span style={{color: "red"}}>{componentErrorMessages.pscChargesOld}</span>}
                            </Grid>
                            <Grid item md={12} sm={12}>
                                <FormControl
                                    fullWidth
                                >
                                    <InlineDatePicker
                                        Date={startDateNew}
                                        handleDateChange={(date) =>
                                            handleDateChange(date, "startDateNew")
                                        }
                                        label="Start Date"
                                        minDate={Date()}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item md={12} sm={12}>
                                <FormControl
                                fullWidth
                                    className={classNames(classes.airlineSelect, classes.formControl)}
                                >
                                    <CustomInput
                                        required
                                        labelText="Revenue Line"
                                        id="revenueLine"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={
                                            {
                                                name: "revenueLine",
                                                type: "text",
                                                onChange: handleChange,
                                            }}
                                    />
                                </FormControl>
                                {componentErrorMessages.revenueLine && <span style={{color: "red"}}>{componentErrorMessages.revenueLine}</span>}
                            </Grid>

                            <Grid item md={12} sm={12}>
              <FormControl 
              fullWidth
              className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Select Currency
                </InputLabel>
                <AutocompleteSelect
                  options={currencyOptions.map((option) => ({
                    value: option.Id,
                    // label: option.Name,
                    label: `${option.Name} (${option.Id})`
                  }))}
                  selectedOption={currency}
                  handleSelectChange={(e, name) => reactSelectChange(e, name)}
                  name={"currency"}
                />
              </FormControl>
              {componentErrorMessages.currency && <span style={{color: "red"}}>{componentErrorMessages.currency}</span>}
            </Grid>

            <Grid item md={12} sm={12}>
              <FormControl 
              fullWidth
              className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Service Type
                </InputLabel>
                <AutocompleteSelect
                  options={serviceTypesOptions.map((option) => ({
                    value: option.Id,
                    label: option.Name,
                  }))}
                  selectedOption={serviceType}
                  handleSelectChange={(e, name) => reactSelectChange(e, name)}
                  name={"serviceType"}
                />
              </FormControl>
              {componentErrorMessages.serviceType && <span style={{color: "red"}}>{componentErrorMessages.serviceType}</span>}
            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={disabled} onClick={handlePscSave} color={"regional"} autoFocus>
                            Set
                        </Button>
                    </DialogActions>
                </Dialog>
            </form>
        </div>
    );
};


export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/PscSettings/settingsPanel.js